import { getPlaybackSourceLabel } from "../utils/playbackSourcePresentation";
import type { RankedPlaybackSource } from "./sourceRanking";
import { planPlaybackFailure, type DecoderEventDecision } from "./decoderEvents";
import { isManagedHlsSource } from "./streamPlan";

type RecoveryPort = {
  recover: (
    currentSourceId: string | undefined,
    rankedSources: RankedPlaybackSource[],
    enabled: boolean,
  ) => {
    stale: boolean;
    exhausted: boolean;
    candidate?: RankedPlaybackSource;
  };
};

export function coordinatePlaybackFailure(input: {
  message: string;
  itemId: string;
  currentSourceId?: string;
  rankedSources: RankedPlaybackSource[];
  recoveryEnabled: boolean;
  positionSeconds: number;
  paused: boolean;
  sessionStarted: boolean;
  sourceGeneration: RecoveryPort;
  applyDecision: (decision: DecoderEventDecision) => void;
}) {
  const recovery = input.sourceGeneration.recover(
    input.currentSourceId,
    input.rankedSources,
    input.recoveryEnabled,
  );
  const fallback = recovery.candidate?.source;
  input.applyDecision(planPlaybackFailure({
    stale: recovery.stale,
    message: input.message,
    sessionStarted: input.sessionStarted,
    fallback: fallback
      ? {
          label: getPlaybackSourceLabel(
            fallback,
            recovery.candidate!.originalIndex,
          ),
          itemId: input.itemId,
          sourceId: fallback.Id ?? "",
          managedHls: isManagedHlsSource(fallback),
          positionSeconds: input.positionSeconds,
          paused: input.paused,
        }
      : undefined,
  }));
}
